import "src/pages/NoMatch/NoMatch.css";
import streetLogoIcon from "src/assets/icon/street_logo_icon.svg";
import baseStyles from "src/global.module.css";
import BottomNavigationBar from "src/components/layout/BottomNavigationBar/BottomNavigationBar";
import Button from "src/components/elements/Button/Button";
import { useNavigate } from "react-router";

const NoMatch = () => {
    const navigate = useNavigate();

    return (
        <div className={baseStyles.page_container}>
            <div className="top-image">
                <img src={streetLogoIcon} alt="" />
            </div>
            <div className="title-container">
                <p className="error-text-404">404</p>
                <p className="page-title-undefined">
                    お探しのページは見つかりません
                </p>
            </div>
            <div className={baseStyles.mb64} />
            <Button
                type="button"
                label="ホームに戻る"
                onClick={() => {
                    navigate("/");
                }}
                colors="primary"
            />
            <BottomNavigationBar />
        </div>
    );
};

export default NoMatch;
